import React, { useState } from 'react'
import isMobile from '../utils/isMobile'
import { Col, DatePicker, Form, Select, Typography } from 'antd'
import moment from 'moment'
import constants from '../assets/constants'
import _ from 'lodash'
import { ReactComponent as CalendarOk } from '../assets/svg/zappyrent_ico_appuntamento.svg'

const PrenotaOra = (props) => (
  <>
    <div className='flex flex-col'>
      <span className='font-semibold text-gray-800 md:text-2xl'>
        Non hai le foto o vuoi un servizio professionale gratuito?
      </span>
      <span className='font-semibold text-gray-600 md:text-xl mt-3'>
        Prendi un appuntamento con uno dei nostri fotografi per aggiungere un
        tour virtuale all'annuncio
      </span>
    </div>
    <button
      type='button'
      onClick={() => props.setUsed(false)}
      className='uppercase w-full md:w-3/6 lg:w-4/6 p-3 lg:px-8 rounded-full border-2 font-semibold border-secondary text-secondary my-5 text-lg hover:border-secondary-light active:border-secondary-dark'
    >
      Prenota Gratis
    </button>
  </>
)

const Prenotazione = (props) => {
  const [used, setUsed] = useState(
    (_.get(props.formValue, 'prenotazioneData') &&
      _.get(props.formValue, 'prenotazioneOrario') &&
      _.get(props.formValue, 'prenotazioneData') !== null &&
      _.get(props.formValue, 'prenotazioneOrario') !== null) ||
      null
  )
  if (used === null) {
    return (
      <div className='flex flex-col items-center'>
        <Col xs={24} lg={20}>
          <PrenotaOra setUsed={setUsed} />
        </Col>
      </div>
    )
  }
  return (
    <div className='flex flex-col items-center'>
      <Col xs={24} md={20} lg={18}>
        {!used && (
          <>
            <span className='font-semibold text-gray-800 text-lg md:text-2xl'>
              Prenota il tuo appuntamento gratuito con il fotografo
            </span>
            <div className='pt-5'>
              <Form.Item
                name='prenotazioneData'
                valuePropName='prenotazioneData'
              >
                <DatePicker
                  placeholder='Seleziona una data'
                  style={{
                    width: '100%'
                  }}
                  format='dddd D MMMM YYYY'
                  showTime={false}
                  showToday={false}
                  value={
                    props.formValue.prenotazioneData
                      ? moment(props.formValue.prenotazioneData)
                      : undefined
                  }
                />
              </Form.Item>
              <Form.Item name='prenotazioneOrario'>
                <Select
                  placeholder='Seleziona un orario'
                  value={props.formValue.prenotazioneOrario}
                >
                  {_.map(constants.orariPrenotazione, (item, index) => (
                    <Select.Option key={`orario_${index}`} value={item.value}>
                      <Typography.Text>{item.label}</Typography.Text>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <button
              type='button'
              onClick={() =>
                _.get(props.formValue, 'prenotazioneData') &&
                _.get(props.formValue, 'prenotazioneOrario')
                  ? setUsed(true)
                  : null}
              className='uppercase w-full md:w-3/6 p-3 px-8 rounded-full border-2 font-semibold border-secondary text-secondary text-lg hover:border-secondary-light active:border-secondary-dark'
            >
              Conferma
            </button>
          </>
        )}
        {used && (
          <div className='flex flex-col font-semibold text-gray-600 text-lg md:text-xl'>
            <p className='text-xl md:text-2xl text-success-accent flex flex-row items-center'>
              <CalendarOk width={40} />
              Appuntamento prenotato!
            </p>
            <p className='text-gray-600'>
              Verrai presto contattato dai nostri operatori per confermare il
              giorno e l'ora dell'appuntamento
            </p>
            <div className='flex flex-row items-center'>
              <span className='pr-4'>Giorno</span>
              <strong className='text-gray-900 font-bold'>
                {moment(_.get(props.formValue, 'prenotazioneData')).format(
                  'dddd D MMMM YYYY'
                )}
              </strong>
            </div>
            <div className='flex flex-row items-center'>
              <span className='pr-4'>Orario</span>
              <strong className='text-gray-900 font-bold'>
                {_.get(
                  _.find(
                    constants.orariPrenotazione,
                    (item) =>
                      item.value ===
                      _.get(props.formValue, 'prenotazioneOrario')
                  ),
                  'label'
                )}
              </strong>
            </div>
            <button
              type='button'
              onClick={() => setUsed(false)}
              className='uppercase w-full md:w-3/6 p-3 mt-3 px-8 rounded-full border-2 font-semibold border-secondary text-secondary text-lg hover:border-secondary-light active:border-secondary-dark'
            >
              Modifica
            </button>
          </div>
        )}
      </Col>
    </div>
  )
}

export default isMobile(Prenotazione)
